import { WSDataItem } from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { INVOICING_PATH } from "../../../modules/Invoicing";
import { Card } from "../../../modules/PaymentApp/components/Card/Card";

type Props = {
  recurringInvoiceId: string;
};

export const InvoiceRecurringSeriesCard: React.FC<Props> = props => {
  const history = useHistory();
  const location = useLocation();

  const viewSeries = () => {
    history.push({
      pathname: `${INVOICING_PATH}/scheduled/${props.recurringInvoiceId}`,
      state: { backPath: location.pathname }
    });
  };

  return (
    <Card>
      <WSDataItem
        label={{
          text: "Recurring series",
          action: {
            label: "View series",
            onClick: viewSeries
          }
        }}
        icon="repeat"
        value="This invoice was generated from a recurring series"
      />
    </Card>
  );
};
